import React from 'react';
import { render } from 'react-dom';

import App from './pages/App';

import './models/init';
import {
  homeRoute, projectsRoute, enHomeRoute, enProjectsRoute, notFoundRoute,
} from './models/routes';
import './ui/styles/Core/_Core.scss';

import {
  appLoadApi, setStepsBlockTopFn,
  setFirstStepOffsetFn, setScrollYFn,
} from './models/app';

const rootElement = document.getElementById('root');

let appMounted = false;

// Mount after the router matched the current URL and always render() fresh:
// static hosting may serve prerendered markup of a different route (SPA
// fallback), and React 17 hydrate() leaves stale nodes on such mismatches.
const mountApp = () => {
  if (appMounted) return;
  appMounted = true;

  render(<App />, rootElement);
};

const appRoutes = [homeRoute, projectsRoute, enHomeRoute, enProjectsRoute, notFoundRoute];

if (appRoutes.some((route) => route.$isOpened.getState())) {
  mountApp();
} else {
  appRoutes.forEach((route) => route.opened.watch(mountApp));
}

window.addEventListener('load', () => {
  appLoadApi.setLoad();

  const elemStep = document.getElementsByClassName('steps-block')[0];
  const isPrerender = navigator.userAgent === 'ReactSnap';

  if (!isPrerender && elemStep) {
    setStepsBlockTopFn(elemStep.offsetTop);
    setFirstStepOffsetFn(elemStep.offsetHeight);
  }

  document.body.addEventListener('scroll', () => {
    setScrollYFn(document.body.scrollTop);
  });
});

window.addEventListener('beforeunload', () => {
  appLoadApi.setUnLoad();
  window.scrollTo(0, 0);
});
